import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

const useProductCode = () => {
  const [searchParams] = useSearchParams();
  const bookingProductCode = useSelector((state) =>
    state.bookings.list.length ? state.bookings.list[0].productCode : null
  );
  const productCode = useMemo(
    () => searchParams.get('productCode') || bookingProductCode,
    [searchParams, bookingProductCode]
  );

  return productCode;
};

export default useProductCode;
